<template>
    <div class="parking_space">
    <v-dialog v-model="dialogDelete" max-width="290">
        <v-card>
            <v-card-title class="headline">
                {{$t('msg_delete_parking_space')}}
            </v-card-title>

            <v-card-text>
                {{$t('msg_eliminar_invitacion_2')}}
            </v-card-text>

            <v-card-actions>
                <v-btn
                        color="primary"
                        @click="dialogDelete = false"
                >
                    No
                </v-btn>
                <v-spacer/>
                <v-btn
                        color="primary"
                        :loading="loadingAddParkingSpace"
                        @click="deleteChargeArea"
                >
                    {{$t('Si')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- Diálogo con formulario -->
    <v-dialog v-model="dialogParkingSpace" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('parking_space') }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <!-- Seccion -->
            <v-autocomplete
                v-model="parkingSection"
                prepend-icon="corporate_fare"
                name="parkingSection"
                item-text="name"
                item-value="id"
                :label="$t('section')"
                :error-messages="errores.id_section"
                :items="parkingSections"
                :no-data-text="$t('no_resultados')"
            >
            </v-autocomplete>
            <!-- Seccion -->
            <v-autocomplete
                v-model="vehicle_type"
                prepend-icon="commute"
                name="vehicle_type"
                item-text="name"
                item-value="id"
                :label="$t('vehicle_type')"
                :error-messages="errores.space_type"
                :items="vehicleTypes"
                :no-data-text="$t('no_resultados')"
            >
            </v-autocomplete>
            <!-- Nombre del Cliente -->
            <v-text-field
                v-model="cliente.name"
                prepend-icon="forklift"
                :label="$t('nombre')"
                :error-messages="errores.number"
                :rules="[v => !!v || 'El nombre es requerido']"
                color="primary"
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="dialogParkingSpace = false">
            {{ $t('cancelar') }}
          </v-btn>
          <v-btn v-if="update" color="primary" :loading="loadingAddParkingSpace" @click="updateParkingSpace">
            {{ $t('modificar') }}
          </v-btn>
          <v-btn v-else color="primary" :loading="loadingAddParkingSpace" @click="createParkingSpace">
            {{ $t('guardar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
        <h2 class="subheading grey--text">{{$t('parking_space')}}</h2>
        <v-container class="my-5">
            <v-layout align-center justify-center fill-height>
            <v-btn
                    class="align-self-end"
                    color="primary"
                    @click="abrirDialogParkingSpace">
                    {{ "+ " + $t('add_parking_space') }}
            </v-btn>
            </v-layout>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-layout class="my-4" align-center justify-center fill-height>
                <v-flex >
                    <v-card-title>
                        {{$t('parking_space')}}
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                :label="$t('Buscar')"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :headers="headers"
                            :loading="loadingParkingSpaces"
                            :items="parkingSpaces"
                            :search="search"
                            class="elevation-1"
                            :rows-per-page-text="$t('filas_por_pagina')"
                            :no-data-text="$t('msg_no_parking_space')"
                            :rows-per-page-items="[
                            {text: '10', value: 10},
                            {text: '20', value: 20},
                            {text: '25', value: 25},
                            {text: this.$t('todos'),
                            value: -1}]"
                    >
                        <template v-slot:items="props">
                            <td class="justify-center layout px-0">
                                <v-icon
                                        class="mr-2"
                                        @click="fillParkingSpace(props.item), errores = [], update = true, id_update = props.item.id"
                                    >
                                    edit
                                </v-icon>
                                <v-icon
                                        medium
                                        color="red"
                                        @click="dialogDelete = true, id_update = props.item.id"
                                >
                                    delete
                                </v-icon>
                            </td>
                            <td>{{ props.item.number }}</td>
                            <td>{{ props.item.space_type_name }}</td>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                            </v-alert>
                        </template>
                        <template v-slot:pageText="props">
                            {{props.rowsPerPage}}
                            {{$t('parking_space')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'

    Vue.use(VeeValidate)
    import { mapState, mapGetters} from 'vuex'

    export default {
        name: "parking_space",
        data: () => ({
            parkingSpaces: [],
            update: false,
            id_update: 0,
            errores: [],
            dialogParkingSpace: false,
            search: '',
            headers: [],
            loadingParkingSpaces: false,
            valid: true,
            cliente: {
                name: ''
            },
            isLoading: false,
            id_empresa: '',
            loadingAddParkingSpace: false,
            parkingSection: '',
            dialogDelete: false,
            parkingSections: [],
            vehicleTypes: [],
            vehicle_type: null,
        }),
        beforeUpdate (){
            this.headers = [
                {
                    text: this.$t('acciones'),
                    align: 'center',
                    sortable: false,
                    value: 'update'
                },
                {
                    text: this.$t('nombre'),
                    align: 'left',
                    sortable: true,
                    value: 'number'
                },
                {
                    text: this.$t('vehicle_type'),
                    align: 'left',
                    sortable: true,
                    value: 'space_type_name'
                }
            ]
        },
        created: function () {
            this.get_extra_data()
        },
        computed: {
            ...mapState(['language']),
            ...mapGetters(['getProfile'])
        },
        methods: {
            getParkingSpaces (){
                this.loadingParkingSpaces = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/Parking/spaces/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    params: {
                        id_section__idEmpresa: this.id_empresa,
                        is_active: true
                    }
                };
                axios(config)
                    .then(response => {
                        this.parkingSpaces = response.data
                        this.loadingParkingSpaces = false
                    })
                    .catch(error => {
                        this.loadingParkingSpaces = false
                        console.log(error)
                    })
            },
            getParkingSections () {
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/Parking/sections/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    params: {
                        idEmpresa: this.id_empresa,
                        is_active: true
                    }
                };
                axios(config)
                    .then(response => {
                        this.parkingSections = response.data
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            getVehicleTypes () {
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/Parking/vehicle-types/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    params: {
                        idEmpresa: this.id_empresa,
                        is_active: true
                    }
                };
                axios(config)
                    .then(response => {
                        this.vehicleTypes = response.data
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            get_extra_data (){
                this.loadingParkingSpaces = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/auth/me',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.id_empresa = response.data.id_company
                        this.getParkingSections()
                        this.getVehicleTypes()
                        this.getParkingSpaces()
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            abrirDialogParkingSpace() {
                this.update = false
                this.id_update = 0
                this.errores = []
                this.dialogParkingSpace = true
                this.$refs.form.resetValidation()
                this.limpiarFormulario()
            },
            fillParkingSpace(item) {
                this.dialogParkingSpace = true
                this.cliente = {
                    name: item.number
                }
                this.vehicle_type = item.space_type || ''
                this.parkingSection = item.id_section
            },
            createParkingSpace() {
                this.errores = []
                if (this.$refs.form.validate()) {
                    this.loadingAddParkingSpace = true
                    const config = {
                        method: 'post',
                        url: 'https://empresa-service.intrare.app/Parking/spaces/',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': this.language ,
                            'authorization': 'Token ' + store.getters.getToken
                        },
                        data: {
                            id_section: this.parkingSection,
                            number: this.cliente.name,
                            space_type: this.vehicle_type
                        }
                    };
                    axios(config)
                        .then(ok => {
                            this.loadingAddParkingSpace = false
                            this.$store.commit('snackbar_activate_true')
                            this.$store.commit('snackbar_change_message', this.$t('msg_parking_space_added'))
                            this.getParkingSpaces()
                            this.dialogParkingSpace = false
                            this.limpiarFormulario()
                            setTimeout(this.clear, 3000);
                        })
                        .catch(error => {
                            this.loadingAddParkingSpace = false
                            if(error.response.status == 400
                                && typeof error.response.data == "object"
                                && error.response.data)
                                this.errores = error.response.data
                        })
                }
            },
            updateParkingSpace() {
                this.errores = []
                if (this.$refs.form.validate()) {
                    this.loadingAddParkingSpace = true
                    const config = {
                        method: 'patch',
                        url: 'https://empresa-service.intrare.app/Parking/spaces/' + this.id_update + '/',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': this.language ,
                            'authorization': 'Token ' + store.getters.getToken
                        },
                        data: {
                            id_section: this.parkingSection,
                            number: this.cliente.name,
                            space_type: this.vehicle_type
                        }
                    };
                    axios(config)
                        .then(ok => {
                            this.loadingAddParkingSpace = false
                            this.$store.commit('snackbar_activate_true')
                            this.$store.commit('snackbar_change_message', this.$t('msg_parking_space_updated'))
                            this.getParkingSpaces()
                            this.dialogParkingSpace = false
                            this.limpiarFormulario()
                            setTimeout(this.clear, 3000);
                        })
                        .catch(error => {
                            this.loadingAddParkingSpace = false
                            if(error.response.status == 400
                                && typeof error.response.data == "object"
                                && error.response.data)
                                this.errores = error.response.data
                        })
                }
            },
            limpiarFormulario() {
                this.cliente = {
                    name: ''
                }
                this.parkingSection = ''
                this.vehicle_type = ''
                this.valid = false
            },
            deleteChargeArea () {
                this.errores = []
                this.loadingAddParkingSpace = true
                const config = {
                    method: 'delete',
                    url: 'https://empresa-service.intrare.app/Parking/spaces/' + this.id_update + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(ok => {
                        this.loadingAddParkingSpace = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_parking_space_deleted'))
                        this.getParkingSpaces()
                        this.dialogDelete = false
                        this.limpiarFormulario()
                        setTimeout(this.clear, 3000);
                    })
                    .catch(error => {
                        this.loadingAddParkingSpace = false
                        if(error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                    })
            },
            clear: function () {
                this.$validator.reset()
                this.$store.commit('snackbar_activate_false')
            }
        }
    }
</script>
